module.exports = __webpack_public_path__ + "img/PowerOfTakt-TaktPlanning.559b52cc.png";